<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 1px 0;">
            <div class="mw-fast-list-box" style=" margin-bottom: 10px;">
                <!-- <span class="mw-fast-list-sub" :class="{'fontRed': tabName == '钢坯', 'fontBold': tabName == '钢坯'}" @click="changeInforTab('钢坯')">钢坯</span>
                <span class="mw-fast-list-sub" :class="{'fontRed': tabName == '带钢', 'fontBold': tabName == '带钢'}" @click="changeInforTab('带钢')">带钢</span> -->
                <span class="mw-fast-list-sub" :class="{'fontRed': tabName == '热轧C料', 'fontBold': tabName == '热轧C料'}" @click="changeInforTab('热轧C料')">热轧C料</span>
            </div>

            <el-row :gutter="20">
                <el-col :span="16">

                    <!-- 左侧第一部分 start -->
                    <div class="bgWhite p10 billet-part-1">
                        <div class="bgGrey p20">
                            <div v-show="billetSwapVo">
                                <el-row :gutter="20">
                                    <el-col :span="8" class="bpart-1-left">
                                        
                                        <h3 class="">{{ tabName }}<small style="font-size: 14px; padding-left: 5px">{{ billetSwapVo.swapDate }}</small></h3>
                                        <div>
                                            <span class="inlineBlock vMid fontBold">{{billetSwapVo.closedPrice}}</span>
                                            <i class="iconfont inlineBlock vMid" :class="{'icon-uparrow fontRed': billetSwapVo.zdVal > 0, 'icon-downarrow fontGreen':  billetSwapVo.zdVal < 0, 'fontNormal':  billetSwapVo.zdVal == 0}" style="font-size: 28px; margin-left: 5px; margin-right: 5px;"></i>
                                            <div class="inlineBlock vMid">
                                                <small :class="{'fontGreen': billetSwapVo.zdVal < 0, 'fontRed': billetSwapVo.zdVal > 0, 'fontNormal': billetSwapVo.zdVal == 0}">{{ billetSwapVo.zdVal }}</small> <br>
                                                <small :class="{'fontGreen': billetSwapVo.zdVal < 0, 'fontRed': billetSwapVo.zdVal > 0, 'fontNormal': billetSwapVo.zdVal == 0}">{{ billetSwapVo.zdRatio + '%' }}</small>
                                            </div>
                                        </div>
                                    
                                    </el-col>
                                    <el-col :span="16" class="bpart-1-right fontLight">
                                        <div class="">
                                            <div>开盘价</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.openedPrice }}</div>
                                            <div>最高价</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.highestVal }}</div>
                                            <div>最低价</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.lowestVal }}</div>
                                            <div>成交量</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.tradingVal }}</div>
                                        </div>
                                        <div class="">
                                            <div>抢持量</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.openInterest }}</div>
                                            <div>涨跌</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.zdVal }}</div>
                                            <div>结算价</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.settlementPrice }}</div>
                                            <div>昨结算</div>
                                            <div class="fontDark fontBold">{{ billetSwapVo.preSettlementPrice }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div v-show="!billetSwapVo" class="font14 textCenter">暂无数据</div>
                        </div>
                    </div>
                    <!-- 左侧第一部分 end -->

                    <div class="bgWhite billet-part-2 mw-modular-box">
                        <h3 class="bgRed fontWhite">K线图</h3>
                        <div v-show="hasKDatas" class="posRel">
                            <!-- <p class="font14" style="padding-left: 65px;">
                                日期： {{ kChartTitle.swapDate }} &nbsp;&nbsp;
                                开盘： {{ kChartTitle.openedPrice }}&nbsp;&nbsp;
                                最高： <span class="fontRed">{{ kChartTitle.highestVal }}</span>&nbsp;&nbsp;
                                最低： <span class="fontGreen">{{ kChartTitle.lowestVal }}</span>&nbsp;&nbsp;
                                收盘： {{ kChartTitle.closedPrice }}
                            </p> -->
                            <div style="height: 507px; margin-top: 10px;" ref="kChart"></div>
                            <span class="posAbs" style="top: 20px; left: 60px; width: 60px; height: 20px;"></span>
                        </div>
                        <div v-show="!hasKDatas" class="font14 textCenter">暂无数据</div>
                    </div>

                </el-col>
                <el-col :span="8" class="billet-part-3">
                    <div v-if="adIDsIndex[0]['list']" style="margin: 0 0 20px 0">
                        <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: -10px; margin-bottom: -10px;">
                            <img :src="item.adPicturePath" alt="" class="w100">
                        </a>
                    </div>
                    <div class="grid-content bgWhite" style="height: 657px; position: relative;">
                        <div v-show="billetSwapList">
                            <div class="mw-table-grid">
                                <div class="mw-table-row bgRed fontWhite">
                                    <div>{{ tabName }}调期</div>
                                    <div>结算价</div>
                                    <div>开盘价</div>
                                    <div>收盘价</div>
                                    <div style="flex: 2">时间</div>
                                </div>
                                <div class="mw-table-row" v-for="(item, index) in billetSwapList" :key="index" :style="{background: index % 2 == 0 || index == 0 ? '#FBF2F1' : 'auto'}">
                                    <div>{{ item.commodityCode }}</div>
                                    <div>{{ item.settlementPrice }}</div>
                                    <div>{{ item.openedPrice }}</div>
                                    <div>{{ item.closedPrice }}</div>
                                    <div style="flex: 2">{{ item.swapDate }}</div>
                                </div>
                            </div>
                            <div class="textRight bgWhite page-box w100" style="padding-top: 10px; position:absolute; bottom: 10px">
                                <el-pagination background :small="true"  @current-change="handleCurrentChange" :current-page="pageNum" :page-size="16" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
                            </div>
                        </div>
                        <div v-show="!billetSwapList" class="font14 textCenter p20">暂无数据</div>
                    </div>
                </el-col>
            </el-row>

            <div class="bgWhite billet-part-4" style="margin-bottom: 20px">
                <h3 class="textCenter">
                    <img src="../../assets/images/billet_1.png" alt="">
                </h3>
                <el-row :gutter="20" class=" p20">
                    <el-col :span="6" class="textCenter">
                        <router-link to="/home/serviceDetail/1">
                            <img src="../../assets/images/billet_5.jpg" alt="">
                            <span class="inlineBlock bgRed fontWhite font16 center">品种简介</span>
                        </router-link>
                    </el-col>
                    <el-col :span="6" class="textCenter">
                        <router-link to="/home/serviceDetail/2">
                            <img src="../../assets/images/billet_6.jpg" alt="">
                            <span class="inlineBlock bgRed fontWhite font16 center">交易规则</span>
                        </router-link>
                    </el-col>
                    <el-col :span="6" class="textCenter">
                        <router-link to="/home/serviceDetail/3">
                            <img src="../../assets/images/billet_7.jpg" alt="">
                            <span class="inlineBlock bgRed fontWhite font16 center">指定交收仓库</span>
                        </router-link>
                    </el-col>
                    <el-col :span="6" class="textCenter">
                        <router-link to="/home/serviceDetail/4">
                            <img src="../../assets/images/billet_8.jpg" alt="">
                            <span class="inlineBlock bgRed fontWhite font16 center">交易指南</span>
                        </router-link>
                    </el-col>
                </el-row>
            </div>

            <div class="mw-modular-box bgWhite billet-part-5">
                <h3 class="textCenter">
                    <img src="../../assets/images/billet_2.png" alt="">
                </h3>
                <div class="get-concat-box center" style="width: 870px;">
                    <div class="inlineBlock vTop" style="margin-top: -15px;">
                        服务热线：400-6565-958 <br>
                        <!-- 总公司：Bejing Head Office <br>
                        地址：北京市海淀区西三环北路89号中国外文大厦A906 <br>
                        电话：010-88570912/88570922传真：010-88570922 <br> -->
                        总部基地：Headquarters Base <br>
                        地址：河北省唐山市高新区建设北路冀东新闻中心5层 <br>
                        电话：0315-5921001/400-6565-958传真：0315-5921091/5921092 <br>
                    </div>
                    <div style="height: auto; width: 155px; margin-left: 100px; margin-top: 0" class="inlineBlock vTop textCenter">
                        <img src="../../assets/images/header_code.png" alt="" srcset="">
                        <p class="textCenter font14">扫一扫关注公众号</p>
                    </div>
                    <div style="height: auto; margin-top: 0; margin-left: 50px" class="inlineBlock vTop textCenter">
                        <img src="../../assets/images/footer_down.png" alt="" srcset="" style="width: 117px; margin-top: 6px; margin-bottom: 4px;">
                        <p class="textCenter font14">唐宋钢铁APP</p>
                    </div>
                </div>
            </div>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import { baseUrl, adIDs } from '../../assets/js/common'
import { KOption } from '../../assets/js/options'
export default {
    name: 'BilletAdjustment',
    components: { ConcatsControl },
    data () {
        return {
            tabName: '钢坯',
            GPVo: '/billetSwap/getTBilletSwapVo',
            GPAll: '/billetSwap/findAll',
            GPList: '/billetSwap/findBilletSwapList/',

            DGVo: '/stripSteelSwap/getTStripSwapVo',
            DGAll: '/stripSteelSwap/findAll',
            DGList: '/stripSteelSwap/findStripSwapList/',

            CVo: '/hotRollingCSwap/getTHotRollingCSwapVo',
            CAll: '/hotRollingCSwap/findAll',
            CList: '/hotRollingCSwap/findHotRollingCSwapList/',



            kChartTitle: {},
            billetSwapVo: {},
            billetSwapList: [],
            totalNum: 0,
            pageNum: 1,
            hasKDatas: true,
            adIDsIndex: [{
                name: 'gptq46',
                id: adIDs['gptq46'],
                list: []
             }],
        }
    },
    mounted () {
        // 初始化内容
        this.getTBilletSwapVo(this.GPVo);
        this.findBilletSwapList(this.GPList);
        this.findAll(this.GPAll);
        this.getAdByAdp();

        this.changeInforTab('热轧C料');
    },
    methods: {
        // 页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

        changeInforTab (name) {
            this.tabName = name;
            this.pageNum = 0;
            if (name == '钢坯') {
                this.getTBilletSwapVo(this.GPVo);
                this.findBilletSwapList(this.GPList);
                this.findAll(this.GPAll);
            } else if (name == '带钢') {
                this.getTBilletSwapVo(this.DGVo);
                this.findBilletSwapList(this.DGList);
                this.findAll(this.DGAll);
            } else if (name == '热轧C料') {
                this.getTBilletSwapVo(this.CVo);
                this.findBilletSwapList(this.CList);
                this.findAll(this.CAll);
            }
        },

        // 获取最新一条信息
        getTBilletSwapVo (url) {
            const self = this;
            self.$get(`${baseUrl.online}${url}`, {}).then(res => {
                if (res.code == 0) {
                    self.billetSwapVo = res.data;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('最新信息获取失败，请重试')
            })
        },

        // 获取分页列表
        findBilletSwapList (url) {
            const self = this;
            self.$post(`${baseUrl.online}${url}${self.pageNum}/16`, {}).then(res => {
                if (res.code == 0) {
                    self.billetSwapList = res.data;
                    self.totalNum = res.totalCount;
                } else {
                    self.$message.error(res.message)
                }
            }).catch(err => {
                // self.$message.error('获取列表信息失败，请重试')
            })
        },
        handleCurrentChange (page) {
            this.pageNum = page;
            if (this.tabName == '钢坯') {
                this.findBilletSwapList(this.GPList);
            } else if (this.tabName == '带钢') {
                this.findBilletSwapList(this.DGList);
            } else if (this.tabName == '热轧C料') {
                this.findBilletSwapList(this.CList);
            }
            // this.findBilletSwapList();
        },

        // 获取k线图数据
        findAll (url) {
            const self = this;

            self.$get(`${baseUrl.online}${url}`, {}).then(res => {
                if (res.code == 0) {
                    let datas = [];
                    let datas_child = [];
                    res.data.forEach((item, index) => {
                        datas_child = [];
                        datas_child.push(item.swapDate);
                        datas_child.push(item.openedPrice);
                        datas_child.push(item.closedPrice)
                        datas_child.push(item.lowestVal)
                        datas_child.push(item.highestVal)
                        datas.push(datas_child);
                    })
                    const kChart = self.$echarts.init(self.$refs.kChart);
                    let option = new KOption(datas);
                    kChart.setOption(option);
                    self.kChartTitle = res.data[res.data.length - 1];
                    self.hasKDatas = res.data ? true : false;
                }
            })
        },


    },
}
</script>

<style scoped>
    @import url('billetAdjustment.css');
</style>